<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Radio, Text, toast } from '@Shelly/shelly-design-system';
	//Helpers
	import { preventSelection } from '../../../../helpers/prevent_selection';
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	//Services
	import { format, t } from 'svelte-i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Stores
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);

	let mode = settings?.[`${get_gen_2_component_channel_structure(device)}`].in_mode;
	let cacheMode = mode;
	let loading = false;

	const modes = ['single', 'dual', 'detached'];

	const modes_i18n = [
		$format(
			'ctr_btn_mode_option_single',
		) /** Single: Controls only through input 1, the action it performs is Open-Stop-Close-Stop when the button is pressed.*/,
		$format('ctr_btn_mode_option_dual') /**Dual: Controls through both inputs for up and down.*/,
		$format('ctr_btn_mode_option_detached') /**Detached*/,
	];

	const handleModeChange = (value) => {
		mode = value;
	};
	const handleSelection = (e, value) => {
		preventSelection(e, value, mode, handleModeChange);
	};
	const sentRequest = async () => {
		if (cacheMode !== mode) {
			loading = true;
			const params = {
				id: device.channel,
				config: { in_mode: mode },
			};

			const res: SettingRequest = await gen2Request(
				device,
				`${get_gen_2_component_from_category(device)}.SetConfig`,
				params,
			);

			if (res.isok) {
				toast.open({
					type: 'success',
					title: $format('btn_mode_scc_toast', {
						values: {
							mode_value: $format(`ctr_btn_mode_option_${mode}`).split(':')[0],
						},
					}),
				});
				cacheMode = mode;
			} else {
				mode = cacheMode;
				toast.open({ type: 'danger', title: $format('error_global') });
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('ctr_btn_mode', { default: 'Control button mode' })}
</Text>

{#each modes as option, index}
	<Radio
		size="m"
		selected={mode}
		value={option}
		on:click={(e) => handleSelection(e, option)}
		id="radio-fj9s2j8">{modes_i18n[index]}</Radio
	>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}
	>{$format('button_save')}</Button
>
